import { render } from "./PersonRegistrationCompleteView.vue?vue&type=template&id=66ae1cd4&scoped=true&ts=true"
import script from "./PersonRegistrationCompleteView.vue?vue&type=script&lang=ts"
export * from "./PersonRegistrationCompleteView.vue?vue&type=script&lang=ts"

import "./PersonRegistrationCompleteView.vue?vue&type=style&index=0&id=66ae1cd4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ae1cd4"]])

export default __exports__